import React from "react";
import SideNav from "@hid-galaxy-ui/galaxy-react/components/SideNav";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useAppSelector } from "../../../redux";
import { useMediaQuery } from "@mui/material";
import BottomNavigationMenu from "../../../common/components/BottomNavigationMenu/BottomNavigationMenu";
import {
  useSessionCanAccessAnyModule,
  useSessionCanAccessModule,
} from "../../../hooks/useSessionPermissions";
import { REPORTS_DASHBOARD_PERMISSION_KEYS as RD_KEYS } from "../../../utils/permissions/reportsDashboardPermissionKeys";
import { SALES_ENGAGEMENT_PERMISSION_KEYS as SE_KEYS } from "../../../utils/permissions/salesEngagementPermissionKeys";
import { SETTINGS_AREA_PERMISSION_KEYS } from "../../../utils/permissions/settingsPermissionKeys";
import "./HIDAdminDashboard.scss";

const HIDAdminDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const pathNameArray = pathName.split("/");
  const isMobile = useMediaQuery("(max-width:1023px)");

  const categoryManagementAccess = useSessionCanAccessModule(
    RD_KEYS.CATEGORY_MANAGEMENT
  );
  const manageEngagementAccess = useSessionCanAccessModule(
    SE_KEYS.MANAGE_ENGAGEMENTS
  );
  const settingsAreaAccess = useSessionCanAccessAnyModule([
    ...SETTINGS_AREA_PERMISSION_KEYS,
  ]);

  const navItems = React.useMemo(
    () =>
      [
        { iconName: "home", key: "home", title: "Home" },
        ...(categoryManagementAccess
          ? [
              {
                iconName: "shieldBlank",
                key: "reports-dashboard",
                title: "Reports Dashboard",
              },
            ]
          : []),
        {
          iconName: "ballot",
          key: "partner-organizations",
          title: "Partner Organizations",
        },
        // {
        //   iconName: "browser",
        //   key: "origo-doctor-poc",
        //   title: "Service operations",
        // },
        ...(manageEngagementAccess
          ? [
              {
                iconName: "fileImport",
                key: "engagement-list",
                title: "Engagements",
              },
            ]
          : []),
        ...(settingsAreaAccess
          ? [{ iconName: "gear", key: "partner-settings", title: "Settings" }]
          : []),
      ] as { iconName: string; key: string; title: string }[],
    [categoryManagementAccess, manageEngagementAccess, settingsAreaAccess]
  );

  React.useEffect(() => {
    if (
      pathName === "/hid-admin/dashboard" ||
      pathName === "/hid-admin/dashboard/"
    ) {
      navigate("/hid-admin/home");
    }
    const element = document.getElementById(
      pathNameArray[pathNameArray.length - 1]
    );
    element?.click();
  }, [pathName, navigate]);

  const onNodeClick = (e: any, key: any) => {
    if (key === "origo-doctor-poc") {
      navigate("/hid-partner-admin/dashboard/dashboard-list");
    } else if (key === "home") {
      navigate("/hid-admin/home");
    } else {
      navigate(`/hid-admin/dashboard/${key}`);
    }
  };

  const mobilePrimaryKeys = React.useMemo(
    () =>
      new Set([
        "home",
        "partner-organizations",
        "engagement-list",
      ] as const),
    []
  );

  const mobileMenuData = React.useMemo(
    () => navItems.filter((item) => mobilePrimaryKeys.has(item.key as any)),
    [navItems, mobilePrimaryKeys]
  );

  const mobileMoreMenuData = React.useMemo(
    () => navItems.filter((item) => !mobilePrimaryKeys.has(item.key as any)),
    [navItems, mobilePrimaryKeys]
  );

  return (
    <div className="hid-admin-dashboard-container">
      {isMobile ? (
        <BottomNavigationMenu
          menuData={mobileMenuData}
          moreMenuDataEnabled={mobileMoreMenuData.length > 0}
          moreMenuData={mobileMoreMenuData}
          onNodeClick={onNodeClick}
        />
      ) : (
        <SideNav
          id="sidenav"
          mode="Colapsed"
          selected={pathNameArray[pathNameArray.length - 1]}
          navItems={navItems}
          onNodeClick={(e, key) => onNodeClick(e, key)}
        />
      )}
      <div className="outlet-view">
        <Outlet />
      </div>
    </div>
  );
};

export default HIDAdminDashboard;